export default __webpack_public_path__ + "static/media/dexterity2.f720a93c.png";